import React from "react";
import { Title } from "react-admin";
import { useNavigate } from "react-router";
import { Grid, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { SpecialistServicePath } from "utils/constants";
import { RowEffect } from "../Partials/RowEffect";

const EnrollmentOptions = () => {
  const navigate = useNavigate();

  const btnData = [
    {
      id: 1,
      name: "Записване за Клинична специалност",
      url: `/${SpecialistServicePath}enroll-specialist/clinical`,
    },
    {
      id: 2,
      name: "Записване за Неклинична специалност",
      url: `/${SpecialistServicePath}enroll-specialist/non-clinical`,
    },
  ];
  return (
    <>
      <Title title={"Записване на специализанти"} />
      <Grid
        container
        spacing={2}
        paddingTop={4}
        paddingX={6}
        gap={2}
      >
        <RowEffect title="Изберете тип на специалност за записване на специализант" />
        {btnData.map(option => (
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
            sx={{
              display: "block",
              margin: "0 auto",
            }}
            key={`idx-${option.id}`}
          >
            <Button
              variant="contained"
              fullWidth
              color="secondary"
              startIcon={<AddIcon />}
              sx={{
                color: "#fff",
                padding: ".7rem",
                boxShadow: "0.5em 0.5em  #ffffff22, 0.5em 0.5em  .4em rgba(47, 45, 52, 0.33)",
              }}
              onClick={() => navigate(option.url)}
            >
              {option.name}
            </Button>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default EnrollmentOptions;
